module.exports = __webpack_public_path__ + "static/media/portfolio5.4be0b8f2.jpg";